import classnames from 'classnames/bind';

import { useModal } from 'hooks/useModal';

import { InlineNotification } from 'components/InlineNotification/InlineNotification';
import { Button } from 'components/Button/Button';

import styles from './Footer.module.scss';

const c = classnames.bind(styles);

type FooterProps = {
  isDirty: boolean;
  isLoading: boolean;
};

export function WidgetFormFooter({ isDirty, isLoading }: FooterProps) {
  const { close } = useModal();

  return (
    <div className={c('footer')}>
      {isDirty && <InlineNotification>Unsaved changes</InlineNotification>}

      <Button variant="secondary" onClick={() => close()}>
        Cancel
      </Button>
      <Button variant="primary" type="submit" loading={isLoading}>
        Save
      </Button>
    </div>
  );
}
